module.exports = __webpack_public_path__ + "img/20210906-1630913542522221.7564e486.png";